import { push as pushAction } from 'connected-react-router';
import React from 'react';
import { connect } from 'react-redux';
import DrawerContext from '../../../components/layout/drawer/context';
import SideNav from '../../../components/layout/SideNav/SideNav';
import { link, logOut as logOutAnalyticsAction } from '../../../modules/analytics/actions';
import { getPathname } from '../../../modules/app/selectors';
import { logOut as logOutAction } from '../../../modules/auth/actions';
import { isAuthenticated, isAuthorized } from '../../../modules/user/selectors';

export default connect(
  state => ({
    pathname: getPathname(state),
    authorized: isAuthorized(state),
    authenticated: isAuthenticated(state)
  }),
  {
    push: pushAction,
    logOut: logOutAction,
    clickLink: link,
    clickLogout: logOutAnalyticsAction
  }
)((props) => (
  <DrawerContext.Consumer>
    {({
      toggle
    }) => (
      <SideNav
        toggle={toggle}
        {...props}
      />
    )}
  </DrawerContext.Consumer>
));
